import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import useServices from "../../../../hooks/useServices.js";
import WorldSkillDataSelect from "../../../../../ui/DataSelect/WorldSkillDataSelect";
import SpecialitiesDataSelect from "../../../../../ui/DataSelect/SpecialitiesDataSelect";

const defaultData = {
    specialities: [],
    worldSkills: []
};

const styles = () => ({
    root: {
        //width: 774,
        display: "flex",
        flexDirection: "column",
        "& .MuiFormLabel-root": {
            whiteSpace: "nowrap"
        },
        "& .MuiInputBase-input.Mui-disabled": {
            color: "#000"
        }
    },
    heading: {
        fontSize: 14,
        display: "flex",
        alignItems: "center",
        color: "#000000",
        margin: "25px 0 15px 0"
    },
    checkbox: {
        "& > .MuiCheckbox-colorPrimary.Mui-checked": {
            color: "rgba(0, 127, 189, 0.7);"
        }
    }
});

const SpecialitiesWorldSkills = ({
    disabled,
    onFormChange,
    initialData,
    classes,
    editmode
}) => {
    const [data, setData] = React.useState(initialData || defaultData);

    const { dataSources, getServicesForm } = useServices();

    useEffect(() => {
        getServicesForm();
    }, []);

    const onChange = (field, value) => {
        const newState = {
            ...data,
            [field]: value
        };

        setData(newState);
        onFormChange(newState);
    };

    return (
        <div className={classes.root}>
            <Typography className={classes.heading}>Компетенции</Typography>
            <WorldSkillDataSelect
              value={data.worldSkills}
              onChange={value => onChange("worldSkills", value)}
              label=""
              dataSource={dataSources.worldSkills}
              disabled={disabled || !editmode}
            />

            <Typography className={classes.heading}>
                Профессии и специальности
            </Typography>
            <SpecialitiesDataSelect
              value={data.specialities}
              onChange={value => onChange("specialities", value)}
              label=""
              dataSource={dataSources.specialities}
              disabled={disabled || !editmode}
            />
        </div>
    );
};

export default withStyles(styles)(SpecialitiesWorldSkills);
